module.exports = __webpack_public_path__ + "img/dark-logo.a1cc816a.png";